module.exports = __webpack_public_path__ + "static/img/8.338f142.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/99/zh/8.png
// module id = P689
// module chunks = 0